import { FieldPathValue, FieldValues, Path, PathValue } from 'react-hook-form';

import { FieldController, FieldControllerProps } from '../FieldController';
import { FieldToggleButton, FieldToggleButtonProps } from './FieldToggleButton';

interface ControllerProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends Path<TFieldValues> = Path<TFieldValues>,
    TValue extends FieldPathValue<TFieldValues, TName> = PathValue<TFieldValues, TName>,
> extends Omit<FieldControllerProps<FieldToggleButtonProps<TValue>, TFieldValues, TName>, 'Field'> {}

export function FieldToggleButtonControlled<
    TFieldValues extends FieldValues = FieldValues,
    TName extends Path<TFieldValues> = Path<TFieldValues>,
    TValue extends FieldPathValue<TFieldValues, TName> = PathValue<TFieldValues, TName>,
>({ validate, ...props }: ControllerProps<TFieldValues, TName, TValue>): JSX.Element {
    return <FieldController Field={FieldToggleButton<TValue>} validate={createValidator({ validate })} {...props} />;
}

function createValidator({ validate }: { validate?: (x: unknown) => string | undefined }) {
    return (x: unknown): string | undefined => {
        if (validate) {
            return validate(x);
        }
        return undefined;
    };
}
